import { render, staticRenderFns } from "./RoomComposition.vue?vue&type=template&id=e57d545c"
import script from "./RoomComposition.vue?vue&type=script&lang=js"
export * from "./RoomComposition.vue?vue&type=script&lang=js"
import style0 from "./RoomComposition.vue?vue&type=style&index=0&id=e57d545c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports